import { render } from "./Sav.vue?vue&type=template&id=ac528002"
import script from "./Sav.vue?vue&type=script&lang=js"
export * from "./Sav.vue?vue&type=script&lang=js"

import "./Sav.vue?vue&type=style&index=0&id=ac528002&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__